<!-- Location -->
<div class="row no-gutters lato">
  <div class="col pr-3 font-weight-bold">Location</div>
</div>
<div class="row no-gutters lato div-location">
  <div class="col text-md">{{ orderRequest.selectedLocation?.name }}</div>
</div>

<!-- Items -->
<div class="row no-gutters lato">
  <div class="col pr-3 font-weight-bold">Order Info</div>
</div>
<div class="">
  <div class="row no-gutters lato" *ngFor="let packageItem of orderRequest.selectedPackageList">
    <ng-container>
      <div class="col text-md">{{ packageItem.name }}</div>
      <div class="text-md">{{ packageItem?.price | currency }}</div>
    </ng-container>
  </div>
</div>

<!-- Total -->
<hr class="view-divider" />
<div class="row no-gutters lato price-text">
  <div class="col text-md">Subtotal</div>
  <div class="text-md">{{ orderRequestPriceInfo.subtotal | currency }}</div>
</div>
<div class="row no-gutters lato price-text">
  <div class="col text-md">Tax ({{ orderRequestPriceInfo.taxRate | percent : '1.2-2' }})</div>
  <div class="text-md">{{ orderRequestPriceInfo.taxTotal | currency }}</div>
</div>
<ng-container *ngIf="orderRequest.hasTip">
<hr class="view-divider" />
<div class="row no-gutters lato price-text">
  <div class="col text-md">Order Total</div>
  <div class="text-md">{{ orderRequestPriceInfo.orderTotal| currency }}</div>
</div>
<div class="row no-gutters lato price-text">
  <div class="col text-md">Tips</div>
  <div class="text-md">{{ orderRequestPriceInfo.tipTotal | currency }}</div>
</div>
</ng-container>
<hr class="view-divider" />
<div class="row no-gutters lato mb-4">
  <div class="col text-md">Total</div>
  <div class="text-md total-text">{{ orderRequestPriceInfo.total | currency }}</div>
</div>

<!--Payment Method Header -->
<app-content-header text="Payment Methods"></app-content-header>

<!-- Existing Card -->
<ng-container *ngIf="selectedPaymentCreditCard">
  <div
    class="payment-list-container"
  >
    <app-payment-tile
      [creditCard]="selectedPaymentCreditCard"
      [selectedCreditCard]="purchaseInfo.paymentCard"
      [showRadio]="true"
      [showChange]="true"
      (selectedChange)="selectExistingPaymentCard($event)"
      (toChange)="changeExistingPaymentCard()"
    ></app-payment-tile>
  </div>
</ng-container>

<!-- New Card -->
<div
  class="payment-tile-container mb-4"
  (click)="handleSelectNewCreditCard()"
  (keyup.enter)="handleSelectNewCreditCard()"
  tabindex="0"
>
  <div class="d-flex justify-content-between align-items-center">
    <div class="d-flex flex-row align-items-center clickable">
      <img
          [src]="getTurnRadioPath"
          alt="Radio Icon"
          height="16"
          width="16"
          class="tile-radio"
      >
      <span
          class="lato bold marine"
          style="font-size: 0.875rem; margin-left: 1rem"
      >Pay with new card</span>
    </div>
  </div>
</div>

<!-- Card Info -->
<ng-container *ngIf="purchaseInfo?.newCard">
  <app-payment-details-form
      #pdForm
      [isEditMode]="false"
      [franchiseId]="orderRequest.selectedLocation.id"
      (submittedInFailure)="paymentAddFailure($event)"
      (submittedInSuccess)="paymentAddSuccess($event)"
  ></app-payment-details-form>
  <div class="col-auto pr-2">
      <mat-checkbox
        #elem
        color="primary"
        [checked]="purchaseInfo?.saveNewCard"
        (change)="elem.checked !== purchaseInfo?.saveNewCard && handleCheckSaveNewCard()"
        (keyup.enter)="handleCheckSaveNewCard()"
      ></mat-checkbox>
      <span
        class="lato marine clickable"
        (click)="handleCheckSaveNewCard()"
        style="font-size: 0.875rem; margin-left: 0.5625rem"
      >Save to Payment Methods</span>
  </div>
</ng-container>


<hr class="bottom-divider" />
<footer class="flex-sm-row flex-column-reverse row no-gutters footer-action div-footer">
  <div class="col pr-sm-1">
    <button
      class="btn btn-outline-danger btn-block"
      (click)="back()"
    >Back</button>
  </div>
  <div
    class="col pl-sm-1">
    <button
      noDoubleClick
      class="btn btn-danger btn-block ml-sm-1 mb-2"
      [disabled]="!canPurchase()"
      (debounceClick)="onPurchase()"
    >Checkout</button>
  </div>
</footer>
